import React, { useState } from "react";
import { Box, Grid, Typography, LinearProgress, Chip } from "@mui/material";
import { useGetDesignEngCriticalDrawingCountQuery } from "store/slices/apis/designEngineeringDashboardSlice";
import { useParams } from "react-router-dom";
import EngineeringListPopup from "./EngineeringListPopup";
import EngineeringPanelHeader from "./EngineeringPanelHeader";

const CriticalDrawings = () => {
    const { projectId } = useParams();
    const [isView, setIsView] = useState(false);
    const [rowData, setRowData] = useState(null);

    const { data: rawData, error, isLoading } = useGetDesignEngCriticalDrawingCountQuery({ projectId })

    const counts = rawData?.data || {};

    const kpiData = [
        {
            label: "For 7 days",
            value: counts.upcomingWithin7Days ?? 0,
            days: "7",
        },
        {
            label: "For 15 days",
            value: counts.upcomingWithin15Days ?? 0,
            days: "15",
        },
        {
            label: "For 30 days",
            value: counts.upcomingWithin30Days ?? 0,
            days: "30",
        },
    ];

    if (isLoading) {
        return (
            <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography>Loading Critical Drawings...</Typography>
            </Box>
        );
    }

    if (error) {
        console.error("Failed to fetch Critical Drawings:", error);
        return (
            <Box sx={{ p: 4, color: 'red', textAlign: 'center' }}>
                Error loading data: {error.status} - {error.data?.message || "Please try again."}
            </Box>
        );
    }

    const handleGetEngineering = (val) => {
        setIsView((prev) => {
            const newState = !prev;
            setRowData(newState ? { days: val } : null);
            return newState;
        });
    }

    const handleClose = () => {
        setIsView(false)
        setRowData(null)
    }

    return (
        <>
            <EngineeringPanelHeader eyebrow="Near-term commitments" title="Critical Drawing Outlook" subtitle="Identify drawings due within the next 7, 15, and 30 days." />
            <Grid container sx={{ p: 2 }}>
                <Grid xs={12} sx={{ display: "none" }}>
                    <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "#3157C8", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                        Near-term commitments
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: { xs: "18px", md: "20px" },
                            color: "#111216",
                            fontFamily: "Poppins, sans-serif",
                            mb: 0.5,
                        }}
                    >
                        Critical Drawing Outlook
                    </Typography>
                    <Typography sx={{ fontSize: "13px", color: "#71819A", mb: 2 }}>
                        Identify drawings due within the next 7, 15, and 30 days.
                    </Typography>
                </Grid>

                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        width: "100%",
                    }}
                >
                    {kpiData.map((item) => (
                        <Box
                            key={item.label}
                            sx={{
                                flex: 1,
                                backgroundColor: "#F8FAFC",
                                border: "1px solid #E7ECF3",
                                px: 3,
                                py: 1.5,
                                borderRadius: 1.5,
                                minWidth: 0,
                                cursor: 'pointer',
                            }}
                            onClick={() => handleGetEngineering(item.days)}
                        >
                            <Typography
                                sx={{
                                    fontSize: 15,
                                    color: "#7D7F81",
                                    wordBreak: "break-word",
                                }}
                            >
                                {item.label}
                            </Typography>
                            <Typography sx={{ fontSize: 24, fontWeight: 600 }}>
                                {item.value}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                {isView &&
                    <EngineeringListPopup header="Upcoming Critical Drawings" open={isView} data={rowData} handleClose={handleClose} label = "ucd" />
                }

            </Grid>
        </>
    );
};

export default CriticalDrawings;
